const HTML = document.querySelector('html');

export default class Sidebar {
  constructor(elt, callbackClose = false) {
    this.elt = elt;
    this.callbackClose = callbackClose;

    

    // Init trigger click close
    const close = this.elt.querySelector('.trigger-close');
    if( close ) {
      close.addEventListener('click', (e) => {
        this.close(e)
      });
    }

    // Overlay
    const overlay = this.elt.querySelector('.sidebar__overlay');
    if( overlay ) {
      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.close(e);
      })
    }
  }

  show() {
    this.elt.classList.add('show')
    HTML.classList.add('show-sidebar')
  }

  close(e) {
    e.stopPropagation();
    e.preventDefault();

    this.elt.classList.remove('show')
    HTML.classList.remove('show-sidebar');

    if( typeof this.callbackClose == 'function' ) {
      this.callbackClose.call();
    }
  }
}